import { createSelector } from "reselect"
import { forEach, find } from "lodash"
import { getAllPositions, getTrades, getConstraintsAndErrors } from "."

export const getBadges = createSelector(
  [getAllPositions, getTrades, getConstraintsAndErrors],
  (positions, trades, constraints) => {
    const badges = {
      buy: 0,
      sell: 0,
      short: 0,
      cover: 0,
      all: 0,
    }

    forEach(positions, position => {
      const constraint = constraints[position.key]
      if (constraint) {
        const trade = find(trades, elem => elem.id === position.id)
        if (trade) {
        // if already in error, no need to check trade
          if (badges[trade.tradeType] !== "error") {
            if (constraint.minError || constraint.maxError) {
              badges[trade.tradeType] = "error"
            } else {
              badges[trade.tradeType]++
              badges.all++
            }
          }
        } else {
          // There's a constraint, but no trade associated with it
          badges.all++
        }
      }
    })

    return badges
  },
)
